// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import storage from 'good-storage';
import store from './store'
import axios from 'axios'
import http from '@/axios/http'
import './permission'
// 将prototypes.js中的内容注册为全局变量方便调用
// 定义全局变量
import prototypes from '@/util/prototypes';

import '../static/css/quill.css'

Vue.config.productionTip = false;
Vue.prototype.$storage = storage;

Vue.prototype.$localJson = axios;
Vue.prototype.$ajax = http;

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/theme/index.css'
Vue.use(Element)

// 获取配置文件中的项目根路径
Vue.prototype.$IMG_BASE_ADDRESS = process.env.IMG_BASE_ADDRESS;
Vue.prototype.$API_ROOT = process.env.API_ROOT;

// Object.keys(prototypes).forEach(key => {
//   Vue.prototype["$" + key] = prototypes[key];
// });

window.router = router;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js